import { commsApi } from './commsApi';

export const pushSupported = () =>
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

const urlBase64ToUint8Array = (base64) => {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const registration = async () => {
  const reg = await navigator.serviceWorker.getRegistration('/');
  return reg || navigator.serviceWorker.ready;
};

// (Re)register this device for background notifications. Requires Notification.permission === 'granted'.
export async function syncPushSubscription(mutedTeamIds = []) {
  if (!pushSupported() || Notification.permission !== 'granted') return false;
  const { public_key: publicKey, enabled } = await commsApi.pushPublicKey();
  if (!enabled || !publicKey) return false;
  const reg = await registration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(publicKey) });
  }
  await commsApi.pushSubscribe(sub.toJSON(), mutedTeamIds);
  return true;
}

export async function hasPushSubscription() {
  if (!pushSupported()) return false;
  try {
    const reg = await registration();
    return Boolean(await reg.pushManager.getSubscription());
  } catch {
    return false;
  }
}

// Called on logout: stop notifications for this device.
export async function removePushSubscription() {
  if (!pushSupported()) return;
  try {
    const reg = await registration();
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    await commsApi.pushUnsubscribe(sub.endpoint).catch(() => {});
    await sub.unsubscribe();
  } catch { /* best effort */ }
}
